import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PermissionHelper } from '../../helpers/permissions.helper';
import { ViewType } from '../../models/enums/viewtype.enum';
import { LayoutService } from '../../services/layout.service';
import { NavigationService } from '../../services/navigation.service';
import { EmptyLayoutPage } from '../../settings/emptypages/emptylayout/empty-layout.page';
import { EmptyDataPage } from '../../settings/emptypages/emptydata/empty-data.page';
import { EmptyUserPage } from '../../settings/emptypages/emptyuser/empty-user.page';
import { EmptyCiPage } from '../../settings/emptypages/emptyci/empty-ci.page';
import { EmptySettingsPage } from '../../settings/emptypages/emptysettings/empty-settings.page';
import { EmptyAboutPage } from '../../settings/emptypages/emptyabout/empty-about.page';

@Component({
    selector: 'settings-page',
    templateUrl: './settings.page.html',
    styleUrls: ['./settings.page.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsPage implements OnInit {

    Instance: any;
    NavigationItems: any;
    SelectedComponent: any;
    ModelNav: any;
    RoleNav: any;
    Style = {
        padding: '10px'
    };
    constructor() {
        this.Instance = this;
        this.NavigationItems = SETTINGS_LIST;
    }

    ngOnInit(): void {
        NavigationService.SelectedPage.next('settings');
        LayoutService.ViewType.next(ViewType.Edit);
        LayoutService.ViewType.next(ViewType.View);
        PermissionHelper.EditPermission.next(false);
    }

    SetComponent(comp: any) {
        this.SelectedComponent = comp;
    }

    async CheckComponent() {
        if (this.SelectedComponent) {
            if (typeof this.SelectedComponent.checkHasChanges === 'function') {
                return await this.SelectedComponent.checkHasChanges();
            }
        }
        return true;
    }
}

export const SETTINGS_LIST: SettingsEntry[] = [
    {
        Caption: '@@Layout',
        ID: 'layout',
        Icon: 'layout-dashboard',
        Index: 0,
        Parent: '',
        Security: {
            Name: 'evidanza.App.Shared.Security.LayoutRight',
            Value: 1
        },
        Children: [],
        EmptyContent: EmptyLayoutPage
    },
    {
        Caption: '@@Data',
        ID: 'data',
        Icon: 'database',
        Index: 1,
        Parent: '',
        Security: {
            Name: 'evidanza.App.Shared.Security.DataRight',
            Value: 1
        },
        Children: [],
        EmptyContent: EmptyDataPage
    },
    {
        Caption: '@@Benutzerverwaltung',
        ID: 'userCont',
        Icon: 'user-cog',
        Index: 2,
        Parent: '',
        Security: {
            Name: 'evidanza.App.Shared.Security.UsermanagementRight',
            Value: 1
        },
        Children: [],
        EmptyContent: EmptyUserPage
    },
    {
        Caption: '@@CorporateIdentity',
        ID: 'ci',
        Icon: 'palette2',
        Index: 3,
        Parent: '',
        Security: {
            Name: 'evidanza.App.Shared.Security.CorporateIdentityRight',
            Value: 1
        },
        Children: [],
        EmptyContent: EmptyCiPage
    },
    {
        Caption: '@@Einstellungen',
        ID: 'settings',
        Icon: 'settings2',
        Index: 5,
        Parent: '',
        Security: {
            Name: 'evidanza.App.Shared.Security.PageSettingsRight',
            Value: 1
        },
        Children: [],
        EmptyContent: EmptySettingsPage
    },
    {
        Caption: '@@About',
        ID: 'about',
        Icon: 'circle-help',
        Index: 6,
        Parent: '',
        Children: [],
        EmptyContent: EmptyAboutPage
    }
];

export interface SettingsEntry {
    Caption: string;
    ID: string;
    Icon: string;
    Index: number;
    Parent: string;
    Security?: SettingsEntrySecurity;
    Content?: any;
    EmptyContent?: any;
    Children?: any[];
    UpdateFunction?: () => Promise<void>;
}

export class SettingsEntrySecurity {
    Name: string;
    Value: number;
}